import { useState, useEffect } from 'react';

export const useVibeController = () => {
  const [vibeConfig, setVibeConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadVibeConfig = async () => {
      try {
        const response = await fetch('/vibe.md');
        const text = await response.text();
        const config = parseVibeConfig(text);
        setVibeConfig(config);
      } catch (error) {
        console.error('Failed to load vibe config:', error);
        // Fallback config
        setVibeConfig(getDefaultConfig());
      } finally {
        setLoading(false);
      }
    };

    loadVibeConfig();
  }, []);

  const parseVibeConfig = (text) => {
    const config = {
      colors: {},
      geometry: {},
      audio: {},
      effects: {}
    };

    const lines = text.split('\n');
    let currentSection = null;

    lines.forEach(line => {
      line = line.trim();
      
      if (line.startsWith('## Color Palette')) {
        currentSection = 'colors';
      } else if (line.startsWith('## Geometric Complexity')) {
        currentSection = 'geometry';
      } else if (line.startsWith('## Audio Settings')) {
        currentSection = 'audio';
      } else if (line.startsWith('## Visual Effects')) {
        currentSection = 'effects';
      } else if (line.startsWith('- ') && currentSection) {
        const [key, value] = line.substring(2).split(': ');
        if (key && value) {
          let parsedValue = value;
          
          // Parse different value types
          if (value === 'true' || value === 'false') {
            parsedValue = value === 'true';
          } else if (!isNaN(value)) {
            parsedValue = parseFloat(value);
          } else if (value.startsWith('[') && value.endsWith(']')) {
            parsedValue = JSON.parse(value);
          }
          
          config[currentSection][key] = parsedValue;
        }
      }
    });

    return config;
  };

  const getDefaultConfig = () => ({
    colors: {
      primary: '#ff6b6b',
      secondary: '#4ecdc4',
      accent: '#45b7d1',
      background: '#2c3e50',
      highlight: '#f39c12'
    },
    geometry: {
      level: 3,
      particleCount: 200,
      geometryType: 'sphere',
      animationSpeed: 1.2
    },
    audio: {
      sensitivity: 0.8,
      frequencyRange: [20, 20000],
      smoothing: 0.85
    },
    effects: {
      bloom: true,
      trails: false,
      rotation: true,
      pulsing: true
    }
  });

  return { vibeConfig, loading };
};